export const GUEST_DISCOVER_RETURN_TO = "/";

export {
  GUEST_EXPLORE_CORRIDORS_TAB,
  GUEST_EXPLORE_EXPERTS_TAB,
} from "@/pages/discover/discoverExplore.const";

/** Matches guest company discover profile width (`DISCOVER_PUBLIC` uses Container xl). */
export const GUEST_DISCOVER_PROFILE_CONTAINER_SIZE = "xl" as const;

export function guestCorridorProfileHref(industry: string, headUserId: string): string {
  return `/discover/corridor/${encodeURIComponent(industry)}/${encodeURIComponent(headUserId)}`;
}

export function guestExpertProfileHref(companyId: string): string {
  return `/discover/expert/company/${encodeURIComponent(companyId)}`;
}